<template>
  <div class="list-faq" v-bind:class="{clickable: clickable}" @click="onClick">
      <li>{{ text }}</li>
  </div>
</template>

<script>
  export default {
    name: 'ListCategory',
    props: {
      text: {
        type: String,
        default: function () {
          return ''
        }
      },
      urlName: {
        type: String,
        default: function () {
          return ''
        }
      }
    },
    methods: {
      onClick: function () {
        if (this.url !== '') {
          setTimeout(() => {
            this.$router.push({name: this.urlName})
          }, 300)
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../node_modules/hotcss/src/px2rem.scss";
  @import "../assets/style/settings.scss";
  @import "../assets/style/flex.scss";
  @import "../assets/style/faq.scss";

.list-faq li {
    color: $color-blue-werun;
    font-size: px2rem(26px);
}

</style>



// WEBPACK FOOTER //
// src/components/ListCategory.vue